import discardLocalSettingsChange from '../mutators/discardLocalSettingsChange';
import { logUsage } from 'owa-analytics';

export default function discardLocalNotificationSettingChange() {
    discardLocalSettingsChange();
    logUsage('NativeNotificationSettingsChangeDiscarded');
}
